import { useFormatLocalizedNumber } from '@pba/react-utils';
import { useCallback } from 'react';

const formattingRules = [
  { decimals: 1, divisor: 100_000, scaleFactor: 1_000_000, suffix: 'M', threshold: 1_000_000 },
  { decimals: 0, divisor: 1000, scaleFactor: 1, suffix: '', threshold: 10_000 },
  { decimals: 0, divisor: 1000, scaleFactor: 1, suffix: '', threshold: 1000 },
  { decimals: 0, divisor: 100, scaleFactor: 1, suffix: '', threshold: 100 },
  { decimals: 0, divisor: 10, scaleFactor: 1, suffix: '', threshold: 10 },
  { decimals: 0, divisor: 1, scaleFactor: 1, suffix: '', threshold: 0 },
] as const;

export const useGetFormatMembersCount = () => {
  const formatLocalizedNumber = useFormatLocalizedNumber();

  return useCallback(
    ({ count }: { count: number }) => {
      const rule = formattingRules.find(({ threshold }) => count >= threshold);

      if (!rule) {
        throw new Error('No formatting rule found for count');
      }

      const { decimals, divisor, scaleFactor, suffix } = rule;
      const formattedNumber = (Math.floor(count / divisor) * divisor) / scaleFactor;

      const numberPart = formatLocalizedNumber({
        numberFormatProperties: {
          maximumFractionDigits: decimals,
          minimumFractionDigits: decimals,
        },
        value: formattedNumber,
      });

      return count < 10 ? numberPart : `${numberPart}${suffix}+`;
    },
    [formatLocalizedNumber],
  );
};
